var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogoLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 49,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo-large_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo-large_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#002161",
  d: "M11.25 6.503 6 6.5l.003 5.247-6 .003L0 .5h11.25zM48 11.75 47.997.5H36.75v6.003l5.25.003.003 5.247zM0 37.25v11.247h11.25v-6L6 42.494v-5.247zm36.75 11.247h11.247V37.25L42 37.253V42.5l-5.25-.003zM27.75 32V17h-7.5v15zM30.375.497 17.625.5v6.003l12.75-.003zm0 42-12.75.003v6l12.75-.003zM-.003 18.122v12.753l6-.003V18.12zM42 18.125v12.753l5.997-.003V18.122z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-large_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h48v48H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-large_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h48v48H0z"
})))));
export { SvgLogoLarge as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-large.761d1b58cc0ffc7ede56.svg";